import { render, staticRenderFns } from "./CaracteristicaPacienteOpcion.vue?vue&type=template&id=f62ab8bc"
import script from "./CaracteristicaPacienteOpcion.vue?vue&type=script&lang=js"
export * from "./CaracteristicaPacienteOpcion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports